import { useTheme } from '@mui/material/styles';
import { Collapse, Grid, Paper } from '@mui/material';
import React, { useEffect, useState } from 'react';
import styles from './styles';
import EirKeepLandlineCollapseTop from './EirKeepLandlineCollapseTop';
import NBIKeepLandlineCollapseContent from './NBIKeepLandlineCollapseContent';
import EirKeepLandlineCollapseContent from './EirKeepLandlineCollapseContent';

/**
 * @name EirValidateBBService - jsx component for validating BB service in  Ascertain Service container
 */
const EirKeepLandlineNumberService = ({
  enableNext,
  bbServiceCheckMark,
  getQAForFixedline,
  areacodes,
  fixedLineValidated,
  bbAccountFound,
  errorUANModal,
  setFixedLineCheckMark,
  bbQAResult,
  setPSTNLandline,
  setfixedlineUan,
  setLandlineno,
  setKeepNumberStateInError,
  uanDetails,
  setEnableNBISubmit,
  isNBIJourney,
}) => {
  const theme = useTheme();
  const [expanded, setExpanded] = useState(false);
  const [radioValue, setRadioValue] = useState();
  const [showContent, setShowContent] = useState(false);
  const [checkMark, setCheckMark] = useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const handleRadioChange = event => {
    if (event.target.value === 'no') {
      if (isNBIJourney) {
        setShowContent(false);
      } else {
        setExpanded(false);
        setShowContent(false);
      }
    } else {
      setShowContent(true);
    }
    setRadioValue(event.target.value);
  };

  useEffect(() => {
    if (expanded) {
      setRadioValue('yes');
      enableNext(false);
    }
  }, [expanded]);
  useEffect(() => {
    if (radioValue === 'no') {
      if (isNBIJourney) {
        setEnableNBISubmit(true);
      } else {
        setCheckMark(true);
        setFixedLineCheckMark(true);
        enableNext(true);
      }
    }
    if (radioValue === 'yes') {
      if (isNBIJourney) {
        setEnableNBISubmit(false);
      } else {
        setCheckMark(false);
        setFixedLineCheckMark(false);
        enableNext(false);
      }
    }
  }, [radioValue]);
  useEffect(() => {
    if (fixedLineValidated && bbServiceCheckMark) enableNext(true);
  }, [fixedLineValidated]);

  return (
    <Grid sx={styles(theme).validateBBService}>
      <Paper sx={isNBIJourney ? styles(theme).nbiLandlineService : styles(theme).landlineService}>
        <EirKeepLandlineCollapseTop
          checkMark={checkMark || fixedLineValidated}
          expanded={expanded}
          handleExpandClick={handleExpandClick}
          numbering={isNBIJourney ? null : '2.'}
          fixedLineValidated={fixedLineValidated}
          text='Would you like to keep your landline number?'
          required='*'
          isNBIJourney={isNBIJourney}
          disableCollapse={!bbServiceCheckMark}
        />
        <Collapse in={expanded} timeout='auto'>
          {isNBIJourney ? (
            <NBIKeepLandlineCollapseContent
              radioValue={radioValue}
              areacodes={areacodes}
              handleRadioChange={handleRadioChange}
              showContent={showContent}
              setfixedlineUan={setfixedlineUan}
              setLandlineno={setLandlineno}
              setKeepNumberStateInError={setKeepNumberStateInError}
              setEnableNBISubmit={setEnableNBISubmit}
              uanDetails={uanDetails}
            />
          ) : (
            <EirKeepLandlineCollapseContent
              radioValue={radioValue}
              bbAccountFound={bbAccountFound}
              areacodes={areacodes}
              setCheckMark={setCheckMark}
              setFixedLineCheckMark={setFixedLineCheckMark}
              errorUANModal={errorUANModal}
              handleRadioChange={handleRadioChange}
              getQAForFixedline={getQAForFixedline}
              showContent={showContent}
              setfixedlineUan={setfixedlineUan}
              setLandlineno={setLandlineno}
              bbQAResult={bbQAResult}
              setPSTNLandline={setPSTNLandline}
              setKeepNumberStateInError={setKeepNumberStateInError}
              uanDetails={uanDetails}
            />
          )}
        </Collapse>
      </Paper>
    </Grid>
  );
};

export default EirKeepLandlineNumberService;
